<div class="jumbotron">
    <h1 class="text-center">{{ i18n._7206_REPORT | translate }}</h1>
    <cmps-client-logo></cmps-client-logo>
</div>
<div class="reports-content">
    <div
        [formGroup]="form"
        class="row"
    >
        <div class="mt-3 col-3">
            <label
                class="mr-3 mb-0"
                id="reportDateRange"
                >{{ i18n._75_START_DATE | translate }}</label
            >
            <div class="d-inline-block">
                <div class="input-group">
                    <input
                        class="form-control"
                        [placeholder]="i18n._646_YYYY_MM_DD | translate"
                        aria-labelledby="reportDateRange"
                        ngbDatepicker
                        formControlName="startDate"
                        #dp="ngbDatepicker"
                    />
                    <div class="input-group-append">
                        <button
                            type="button"
                            class="btn btn-secondary cmps-cdk-py-0dot5"
                            aria-label="Toggle date picker"
                            [attr.aria-expanded]="dp.isOpen()"
                            (click)="dp.toggle()"
                        >
                            <cmps-icon svgIcon="calendar"></cmps-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-3 col-3">
            <label
                class="mr-3 mb-0"
                id="reportDateRange"
                >{{ i18n._73_END_DATE | translate }}</label
            >
            <div class="d-inline-block">
                <div class="input-group">
                    <input
                        class="form-control"
                        [placeholder]="i18n._646_YYYY_MM_DD | translate"
                        aria-labelledby="reportDateRange"
                        ngbDatepicker
                        formControlName="endDate"
                        #dpEnd="ngbDatepicker"
                    />
                    <div class="input-group-append">
                        <button
                            type="button"
                            class="btn btn-secondary cmps-cdk-py-0dot5"
                            aria-label="Toggle date picker"
                            [attr.aria-expanded]="dpEnd.isOpen()"
                            (click)="dpEnd.toggle()"
                        >
                            <cmps-icon svgIcon="calendar"></cmps-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-3 col-3">
            <label
                class="mr-3 mb-0"
                id="reportRole"
                >{{ i18n._59_ROLE | translate }}</label
            >
            <div class="d-inline-block select-roles">
                <ng-select
                    [options]="roles"
                    [placeholder]="'_'"
                    ariaLabelledBy="reportRole"
                    [multiple]="false"
                    [multipleWithCheckbox]="true"
                    [selectAllLabel]="i18n._994_SELECT_ALL | translate"
                    [allOptionsSelectedLabel]="
                        i18n._7226_ALL_OPTIONS_SELECTED | translate
                    "
                    formControlName="roles"
                >
                </ng-select>
            </div>
        </div>
        <div class="mt-3 col-3 text-end">
            <button
                type="button"
                class="btn btn-primary"
                [disabled]="form.invalid"
                (click)="onGenerateClick()"
            >
                {{ i18n._7207_GENERATE | translate }}
            </button>
        </div>
    </div>
    <cmps-wait-status *ngIf="pendingData"></cmps-wait-status>
    <div *ngIf="items && items.length > 0">
        <div class="mt-3">
            <button
                type="button"
                class="btn btn-primary"
                (click)="onExportClick()"
            >
                {{ i18n._7213_EXPORT_DATA | translate }}
            </button>
        </div>
        <div class="table-container mt-3 cmps-reports-table">
            <table class="table">
                <tr>
                    <th
                        class="clickable"
                        (click)="onSort('userName')"
                    >
                        {{ i18n._102_USER_NAME | translate }}
                        <cmps-icon
                            [svgIcon]="sort | sortArrowReports: 'userName'"
                        ></cmps-icon>
                    </th>
                    <th
                        class="clickable"
                        (click)="onSort('roleName')"
                    >
                        {{ i18n._59_ROLE | translate }}
                        <cmps-icon
                            [svgIcon]="sort | sortArrowReports: 'roleName'"
                        ></cmps-icon>
                    </th>
                    <th
                        class="clickable"
                        (click)="onSort('loginAttemp')"
                    >
                        {{ i18n._7299_TOTAL_LOGINS | translate }}
                        <cmps-icon
                            [svgIcon]="sort | sortArrowReports: 'loginAttemp'"
                        ></cmps-icon>
                    </th>
                </tr>
                <ng-template
                    ngFor
                    let-item
                    [ngForOf]="items"
                >
                    <tr
                        class="clickable"
                        (click)="onToggleDetail(item)"
                    >
                        <td>
                            <div>
                                {{ item.userName }}
                            </div>
                        </td>
                        <td>
                            <div>{{ item.roleName }}</div>
                        </td>
                        <td>
                            <div class="text-center">
                                {{ item.loginAttemp }}
                            </div>
                        </td>
                    </tr>
                    <tr *ngIf="item.expanded">
                        <td colspan="3">
                            <div>
                                <h5>
                                    {{ i18n._7298_LOGIN_DATE | translate }}:
                                </h5>
                                <cmps-wait-status
                                    *ngIf="pendingDetailData"
                                ></cmps-wait-status>
                                <ul>
                                    <li *ngFor="let detail of item.details">
                                        {{
                                            detail.loginDate
                                                | cmpsDate: 'y-MM-dd'
                                        }}
                                    </li>
                                </ul>
                                <div
                                    *ngIf="
                                        !item.details ||
                                        item.details.length == 0
                                    "
                                >
                                    {{
                                        i18n._7413_NO_RESULTS_FOUND | translate
                                    }}
                                </div>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <tr *ngIf="!items || items.length == 0">
                    <td colspan="3">
                        {{ i18n._7413_NO_RESULTS_FOUND | translate }}
                    </td>
                </tr>
            </table>
        </div>
    </div>
</div>
